export default __webpack_public_path__ + "static/media/coresanscr95it-webfont.06ae43fd.woff";